module.exports = __webpack_public_path__ + "static/media/illustration_1.57648891.jpg";